import React,{useEffect, useState} from 'react'
import Layout from '../../components/Layout/Layout'
import axios from "axios";
import {useNavigate} from 'react-router-dom'
import toast from 'react-hot-toast';
import '../../style/AuthStyle.css';
import { AutoComplete } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import Compressor from 'compressorjs';
import { SERVER_API } from '../../fileWithConstants'
const ImageCompress = () => {
    const [fabricPhoto, setFabricPhoto] = useState("");
    const navigate = useNavigate();
    const [name, setName] = useState('');
    
    const [category, setCategory] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [supplier, setSupplier] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState('');
    const [qty, setQty] = useState('');
    const [price, setPrice] = useState('');
    const [fabrics, setFabrics] = useState([]);
    const [allFabrics, setAllFabrics] = useState([]);
    const [fabtype, setFabtype] = useState(0);
    const [option, setOption] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const handleSubmit = async(e)=>{
        e.preventDefault();
        if(!submitting) {
          try {
            new Compressor(fabricPhoto, {
              quality: 0.6,
              width:800,
              success(result) {
                const formData = new FormData();
                formData.append("name", name);
                formData.append("fabtype", fabtype);
                formData.append("category", selectedCategory);
                formData.append("supplier", selectedSupplier);
                formData.append("qty", qty);
                formData.append("price", price);        
                formData.append("fabric_photo", result,result.name);
                const {data} = axios.post(`${SERVER_API}/api/v1/fabric/upload-image`,formData,{
                  headers:{"Content-Type":"multipart/form-data"}
                });
                
                if(data?.success){
                  toast.success(data?.message)
                  /* navigate('/fabric-list') */
                }else{
                  toast.error(data?.message)
                }
                setName("");
                setSelectedCategory("");
                setSelectedSupplier("");
                setQty("");
                setPrice("");
                setFabricPhoto("");
                //window.location.reload();
                navigate('/dashboard/fabric-list')
              },
              error(err) {
                console.log(err.message);
              },
            });
          } catch (error) {
            console.log(error)
          } finally {
            setSubmitting(false);
          }
        }
    }
    
    const getAllSupplier = async()=>{
      try {
        const {data} = await axios.get(`${SERVER_API}/api/v1/supplier/get-all-supplier`);
        if(data?.success && data?.suppliers?.length>0){
          setSupplier(data?.suppliers)
        }
      } catch (error) {
        console.log(error)
      }
    }
    
    const getAllFabricCategory = async()=>{
      try {
        const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabric-category`);
        if(data?.success){
          setCategory(data?.category)
        }
      } catch (error) {
        console.log(error)
      }
    }
    
    const getAllFabric = async()=>{
      try {
        const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabricdata`);
        if(data?.success){
          const fb_main_arr = data?.fabrics;
          setAllFabrics(fb_main_arr);
          const fab_names = fb_main_arr.map((fab)=>fab.name)
          setFabrics(fab_names);
        }
      } catch (error) {
        console.log(error)
      }
    }
    
    const getFabricData = async(item)=>{
      //console.log(item)
      const f_code = await allFabrics.filter((fab)=>fab.name===item).map((f)=>f);
      //console.log(f_code)
      if(f_code?.length>0){
     
        setFabtype(f_code[0].id)
        setOption(' readonly');
        setSelectedCategory(f_code[0].category);
        setSelectedSupplier(f_code[0].supplier);
      }else{
        setFabtype(0)
        setOption('');
        setSelectedCategory("");
        setSelectedSupplier("");
      }
    }
    
    useEffect(()=>{
      getAllFabric();
      getAllFabricCategory();
    },[])
    
    useEffect(()=>{
      getAllSupplier();
    },[])
    
    const onFileChange = (e) => {
      setFabricPhoto(e.target.files[0]);
    };
    
      return (
        <Layout title={'Add Fabric'}>
         
          <div className='form-container'>
      <form onSubmit={handleSubmit} encType="multipart/form-data" className='form-section'>
          <h4 className='title'>Add Fabric</h4>
          <div className='form-box'>
          <div className="mb-3">
            <label>Fabric Name (Existing or New Name)*</label>
            <AutoComplete data={fabrics} name='name'
            onPaste={(e) => {
              e.preventDefault();
              return false;
            }} onChange={(value,e)=>{ setName(value); setSelectedCategory(""); setSelectedSupplier("");  setFabtype(0); setOption(''); }} defaultValue="" onSelect={(item,e)=>getFabricData(item)} />
            <input name="fabtype" value={fabtype} type="hidden" />
          </div>
    
          <div className="mb-3">
            <label>Choose Category*</label>
            <select value={selectedCategory} className="form-select selectpicker form-control" readOnly={option}  name='category' onChange={(e)=>setSelectedCategory(e.target.value)}>
            <option value={""}>--Select--</option>
              {category?.map((c, index)=>(
                <option value={c.id} key={index}>{c.name}</option>
              ))} 
            </select>
          </div>
          
          <div className="mb-3">
          <label>Quantity (metres)*</label>
              <input type="number" 
              className="form-control"
              value={qty}
              name='qty'
              onChange={(e)=>setQty(e.target.value)}
              required
               />
          </div>
    
          <div className="mb-3">
          <label>Price/metre*</label>
              <input type="number" 
              className="form-control"
              value={price}
              name='price'
              onChange={(e)=>setPrice(e.target.value)}
              required
               />
          </div>
    
          <div className="mb-3">
            <label>Supplier*</label>
            <select value={selectedSupplier} className="form-select form-control" readOnly={option} name='supplier' onChange={(e)=>setSelectedSupplier(e.target.value)}>
              <option value={""}>--Select--</option>
              {supplier?.map((s, index)=>(
                <option value={s.v_id} key={index}>{s.code}</option>
              ))}         
            </select>
          </div>
    
          <div className="mb-3">
            <label>Picture Upload*</label>
           <input className="form-control" name='fabric_photo' type="file" accept="image/png, image/jpg, image/jpeg" onChange={onFileChange}/>
          </div>
          <div className='submit-button-box'><button type="submit" className="btn btn-dark form-control">Add</button></div>
          </div>      
          </form>
      </div>
        </Layout>
      )
}

export default ImageCompress
